import { eFeePropertyNames } from '../../../types/order/fees/eFeePropertyNames';
import { ISettlementItemData } from '../../../types/order/fees/ISectionData';

export const PayeeIsEditable = (
  currentSettlementItem?: Pick<ISettlementItemData, 'stringSettlementStatementPropertyValues'>
) => {
  return !!currentSettlementItem?.stringSettlementStatementPropertyValues[eFeePropertyNames.Name]?.startsWith(
    'Sales Tax -'
  );
};
